import FeatureToggle from './pdc-feature-toggle-js';

let feature_toggle = null;

const asyncFilter = async (arr, predicate) => {
  const results = await Promise.all(arr.map(predicate));

  return arr.filter((_v, index) => results[index]);
};

const asyncSome = async (arr, predicate) => (await asyncFilter(arr, predicate)).length > 0;
const asyncEvery = async (arr, predicate) => (await asyncFilter(arr, predicate)).length === arr.length;

const dispatchEvent = (vnode, name, value) => {
  const event = new Event(name);
  event.value = value;
  vnode.elm.dispatchEvent(event);
};

const isFeatureEnabled = async (value, modifiers) => {
  if (!feature_toggle) {
    return false;
  }

  const { disabled } = modifiers;

  if (Array.isArray(value)) {
    const { some } = modifiers;
    const cb = feature_toggle.isFeatureEnabled.bind(feature_toggle);

    if (some) {
      if (disabled) {
        return !(await asyncEvery(value, cb));
      }
      return asyncSome(value, cb);
    }
    if (disabled) {
      return !(await asyncSome(value, cb));
    }
    return asyncEvery(value, cb);
  }

  return disabled ? !(await feature_toggle.isFeatureEnabled(value)) : feature_toggle.isFeatureEnabled(value);
};

export const getFeatureEnabledStandalone = async (feature_name) => {
  if (!feature_toggle) {
    console.warn('FeatureToggle not initialized yet!');
    return false;
  }
  return feature_toggle.isFeatureEnabled(feature_name);
};

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.prototype.$init_feature_toggle = async (conf) => {
      feature_toggle = new FeatureToggle(conf);
      await feature_toggle.isFeatureEnabled('');
    };
    Vue.prototype.$getFeatureEnabled = getFeatureEnabledStandalone;
    Vue.directive('feature', {
      async bind(el, { value, modifiers }, vnode) {
        dispatchEvent(vnode, 'feature-loading', true);

        const original_display = el.style.display || 'block';
        el.style.display = 'none';

        if (feature_toggle && await isFeatureEnabled(value, modifiers)) {
          el.style.display = original_display;
        } else {
          el.remove();
        }

        dispatchEvent(vnode, 'feature-loading', false);
      }
    });
  }
};
